import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Grid, List } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useVideoDashboardStore } from '@/store/videoDashboard';
import { ViewMode } from '@/store/videoDashboard/types';
import { cn } from '@/lib/utils';

export const ViewToggle = () => {
  useLanguage();
  const viewMode = useVideoDashboardStore(state => state.viewMode);
  const setViewMode = useVideoDashboardStore(state => state.setViewMode);
  
  return (
    <div className="flex gap-1 p-1 rounded-[12px] border border-[#E2E8F0] bg-white">
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "justify-center gap-2 h-10 px-4 rounded-[10px] transition-all duration-[250ms]",
          viewMode === 'grid' 
            ? "bg-[#297CFF] text-white hover:bg-[#297CFF]"
            : "bg-white text-[#374151] hover:bg-white hover:text-[#374151]"
        )}
        onClick={() => setViewMode('grid')}
      >
        <Grid className="h-4 w-4" />
        <span className="text-sm font-medium">{translateInterfaceText("Grade")}</span>
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "justify-center gap-2 h-10 px-4 rounded-[10px] transition-all duration-[250ms]",
          viewMode === 'list' 
            ? "bg-[#297CFF] text-white hover:bg-[#297CFF]"
            : "bg-white text-[#374151] hover:bg-white hover:text-[#374151]"
        )}
        onClick={() => setViewMode('list')}
      >
        <List className="h-4 w-4" />
        <span className="text-sm font-medium">{translateInterfaceText("Lista")}</span>
      </Button>
    </div>
  );
};
